import { render } from "./validationErrorModal.vue?vue&type=template&id=2bb92281&ts=true"
import script from "./validationErrorModal.vue?vue&type=script&lang=ts"
export * from "./validationErrorModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__